var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":"mobile","sortable":"","label":"Mobil","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n    "+_vm._s(_vm._f("phone")(scope.row.mobile))+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }